import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { MessagingService } from '@app/core';
import {
  NotificationActionTypes,
  // GetPermission,
  // GetPermissionSuccess,
  // GetPermissionFailure
  SendTeamNotification,
  SendTeamNotificationSuccess,
  SendTeamNotificationFailure,
} from '../actions/notification.actions';
import { RequestStatus, NGXLogger } from '@app/shared';

@Injectable()
export class NotificationEffects {

  constructor(
    private actions: Actions,
    private messagingService: MessagingService,
    private router: Router,
    private logger:NGXLogger,
  ) {

  }

    //@Effect()
    // GetPermission: Observable<any> = this.actions
    //     .ofType(NotificationActionTypes.GET_PERMISSION)
    //     .debounceTime(200)
    //     .map((action: GetPermission) => action.payload)
    //     .switchMap(payload => {
    //       this.logger.debug(payload)
    //       return this.messagingService.getPermission()
    //         // .map((result) => {
    //         //   this.logger.debug(result)
    //         //   return new GetPermissionSuccess({token:result})
    //         // })
    //         // .catch((error) => {
    //         //   this.logger.debug(error);
    //         //   return Observable.of(new GetPermissionFailure({ error: error }));
    //         // });
    //     })


    // @Effect({ dispatch: false })
    // GetPermissionSuccess: Observable<any> = this.actions.pipe(
    //   ofType(NotificationActionTypes.GET_PERMISSION_SUCCESS),
    //   tap((result) => {
    //     this.logger.debug(result, ' in tap')
    //   })
    // );
    //
    // @Effect({ dispatch: false })
    // GetPermissiFailure: Observable<any> = this.actions.pipe(
    //   ofType(NotificationActionTypes.GET_PERMISSION_FAILURE)
    // );


    @Effect()
    SendTeamNotification: Observable<any> = this.actions
        .ofType(NotificationActionTypes.SEND_TEAM_NOTIFICATION)
        .debounceTime(200)
        .map((action: SendTeamNotification) => action.payload)
        .switchMap(payload => {
          this.logger.debug(payload)
          return this.messagingService.sendTeamNotification(payload.contacts , payload.subject, payload.message, payload.teams, payload.type, payload.all, payload.data)
            .map((result) => {
              this.logger.debug(result);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Notification has been sent`;
              return new SendTeamNotificationSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SendTeamNotificationFailure({ error: error }));
            });
        })


    @Effect({ dispatch: false })
    SendTeamNotificationSuccess: Observable<any> = this.actions.pipe(
      ofType(NotificationActionTypes.SEND_TEAM_NOTIFICATION_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    SendTeamNotificationFailure: Observable<any> = this.actions.pipe(
      ofType(NotificationActionTypes.SEND_TEAM_NOTIFICATION_FAILURE)
    );

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/notification.effects.ts